import { types } from "mobx-state-tree"

const UltimateNationality = types.model('UltimateNationality', {
    id: types.identifierNumber,
    name: types.string,
    code: types.string,
})

export default UltimateNationality
